import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import React from 'react';

const OrganizationItemIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 24 24"
      >
        <g id="Symbols">
          <g id="Icon-_x2F_-Data-Model" transform="translate(-2.000000, -2.000000)">
            <path
              id="Shape-Copy-4"
              d="M9,16h2.1c0.5,0,0.9,0.7,0.9,1.6l0,0v4.8c0,0.9-0.4,1.6-0.9,1.6l0,0H4.9
			C4.4,24,4,23.3,4,22.4l0,0v-4.8C4,16.7,4.4,16,4.9,16l0,0H7l0-2.6C7,13,7.3,13,7.8,13l5.2,0v-1h-2.1c-0.5,0-0.8-0.6-0.9-1.4l0-0.2
			V5.6C10,4.7,10.4,4,10.9,4l0,0h6.2C17.6,4,18,4.7,18,5.6l0,0v4.8c0,0.9-0.4,1.6-0.9,1.6l0,0H15v1l5.2,0c0.4,0,0.7,0,0.8,0.3l0,0.1
			V16h2.1c0.5,0,0.8,0.6,0.9,1.4l0,0.2v4.8c0,0.9-0.4,1.6-0.9,1.6l0,0h-6.2c-0.5,0-0.9-0.7-0.9-1.6l0,0v-4.8c0-0.9,0.4-1.6,0.9-1.6
			l0,0H19v-1H9V16z M10,18H6v4h4V18z M22,18h-4v4h4V18z M16,6h-4v4h4V6z"
            />
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
};

export default OrganizationItemIcon;
